import React, { useEffect } from "react";
import logo from "../../../assets/logo-dark.svg";
import { Button } from "../../../components/button";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { AuthContext } from "../../../contexts/AuthContext";

const Unauthorized = () => {
  const { isAuthenticated, logout, user } = useKindeAuth();
  const { authContext } = React.useContext(AuthContext);

  return (
    <div className="flex h-screen justify-center items-center bg-black">
      <div className="sm:px-12 md:px-18 lg:px-12 sm:py-8 lg:py-12 rounded-lg bg-white flex rounded-large items-center justify-center flex-col">
        <img src={logo} alt="Opspot" />
        <div className="pt-12 w-full">
          <p className="pb-8 text-center leading-8">
            {authContext.user.email} <br />
            you do not have permission to view this page :-(
          </p>
          {isAuthenticated && <Button onClick={logout}>Logout</Button>}
        </div>
      </div>
    </div>
  );
};

export { Unauthorized };
